module.exports = require("./eo.js");